/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M0 3.75C0 2.2312 1.2312 1 2.75 1h10.5C14.7688 1 16 2.2312 16 3.75v8.5c0 1.5188-1.2312 2.75-2.75 2.75H2.75C1.2312 15 0 13.7688 0 12.25v-8.5ZM2.75 2.5c-.6904 0-1.25.5596-1.25 1.25v8.5c0 .6904.5596 1.25 1.25 1.25h10.5c.6904 0 1.25-.5596 1.25-1.25v-8.5c0-.6904-.5596-1.25-1.25-1.25H2.75Zm1.2197 1.9697a.75.75 0 0 1 1.0607 0l3 3L8.5607 8l-.5303.5303-3 3a.75.75 0 0 1-1.0607-1.0606L6.4394 8 3.9697 5.5303a.75.75 0 0 1 0-1.0606ZM9 10.25a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75H9Z"
      clipRule="evenodd"
    />
    <defs></defs>
  </>,
  'Prompt'
);
